import { FC, ReactElement, useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { Link } from 'react-router-dom'
import { v4 as uuid } from 'uuid'
import { ReactComponent as Arrow } from '../../assets/icons/arrow-down.svg'
import close from '../../assets/icons/close.svg'
import { MD } from '../../utils/screenSizes'
import { useSideNavigation } from './context'
import { Container, ContainerSideNavigationItem, ContainerSideNavigationMenu } from './styles'

type SideNavigationProps = {
  to?: string
}

type SideNavigationMenuProps = {
  name?: string
  title?: string
  icon?: ReactElement
  children?: ReactElement | ReactElement[]
  isDefaultOpened?: boolean
}

const SideNavigation: FC<SideNavigationProps> = ({ children }): ReactElement | null => {
  const { isVisible, setVisibility } = useSideNavigation()
  const isTablet = useMediaQuery({ query: `(max-width: ${MD})` })

  if (isTablet && isVisible === false) return null

  return (
    <Container>
      {isTablet && (
        <button className='modal_close' type='button' onClick={() => setVisibility(false)}>
          <img src={close} alt='fechar modal' />
        </button>
      )}
      {children}
    </Container>
  )
}

export const SideNavigationMenu: FC<SideNavigationMenuProps> = ({
  name,
  isDefaultOpened,
  icon,
  title,
  children
}): ReactElement => {
  const { bind, toggle, accordion } = useSideNavigation()
  const [id] = useState(name || uuid())

  const isOpen = !!(accordion[id] == null ? isDefaultOpened : accordion[id])

  const existsBind = accordion[id] != null

  useEffect(() => {
    if (!existsBind) bind(id)
  }, [existsBind, id, bind])

  return (
    <ContainerSideNavigationMenu $isOpen={isOpen}>
      <button
        onClick={() => toggle(id)}
        type='button'
        className='title_container'
      >
        {icon && <div className='icon'>{icon}</div>}
        {title && <div className='title'>{title}</div>}
        <div className='arrow'>
          <Arrow />
        </div>
      </button>
      <ul className='inside'>
        {children}
      </ul>
    </ContainerSideNavigationMenu>
  )
}
export const SideNavigationItem: FC<SideNavigationProps> = ({ children, to }): ReactElement => {
  const { setVisibility } = useSideNavigation()

  return (
    <ContainerSideNavigationItem onClick={() => setVisibility(false)}>
      {to && <Link to={to}>{children}</Link>}
      {!to && children}
    </ContainerSideNavigationItem>
  )
}

export default SideNavigation
